// extracted by mini-css-extract-plugin
module.exports = {"main":"Header_main__1LjXw","logo":"Header_logo__3T0lc","closeButton":"Header_closeButton__1rdZu"};